export default __webpack_public_path__ + "static/media/Shemite Wayfarer Leggings.686a7fc9.jpg";